import React, { useState, forwardRef } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { motion } from 'framer-motion';
import ModalImagenExpandida from './ModalImagenExpandida';

import {productos} from '../data/Productos'


const NuestrosProductos = React.forwardRef((props, ref) => {
    const navigate = useNavigate();
    const [imagenExpandida, setImagenExpandida] = useState(null);

    const manejarClickTarjeta = (nombre) => {
        const nombreEnRuta = nombre.toLowerCase().replace(/\s+/g, "-");
        navigate(`${nombreEnRuta}`);
    };

    return ( 
        <>
            <H2>Nuestros Productos</H2>
            <SectionProductos ref={ref}>
                {productos.map((producto) => {
                    const esSuperOferta = producto.nombre === "Super Ofertas";

                    return (
                        <motion.div 
                            key={producto.id} 
                            onClick={() => manejarClickTarjeta(producto.nombre)}
                            initial={{opacity: .6, scale: .7}}
                            whileInView={{ opacity: 1, scale: 1, delay: 0.3 }}
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.95 }}
                            animate={esSuperOferta ? {
                                scale: [1, 1.05, 1],
                                rotate: [0, 1, -1, 0],
                                transition: {
                                    repeat: Infinity,
                                    duration: 1.5,
                                    ease: "easeInOut"
                                }
                            } : {}}
                        >
                            <ProductosContainer>
                                {esSuperOferta && (
                                    <OfertaBadge
                                        initial={{ opacity: 0, y: -10 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.5 }}
                                    >
                                        🔥 Super Ofertas
                                    </OfertaBadge>
                                )}
                                <motion.img
                                    loading='lazy'
                                    src={producto.img}
                                    alt={producto.nombre}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setImagenExpandida(producto.img);
                                    }}
                                />
                                <h2>{producto.nombre}</h2>
                                <p>{producto.descripcion}</p>
                                {producto.sePuedeMotorizar === true ? 
                                <>
                                    <p>Se puede motorizar</p>
                                    <button type='button'>Ver más sobre: {producto.nombre}</button>
                                </>
                                : <button type='button'>Ver más sobre: {producto.nombre}</button>}
                            </ProductosContainer>
                        </motion.div>
                    );
                })}
            </SectionProductos>
            <ModalImagenExpandida
                imagen={imagenExpandida}
                onClose={() => setImagenExpandida(null)}
            />
        </>
    );
});
const SectionProductos = styled.section `
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    flex-grow: 1;
    gap: 30px;
    padding: 35px 0;
    overflow-x: hidden;
`

const H2 = styled.h2 `
    text-align: center;
`
const ProductosContainer = styled.div `
    position: relative;
    background-color: #EDEDED;
    margin: 0 20px;
    border-radius: 8px;
    box-shadow: 0px 4px 6px #0008;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    padding: 15px 5px;
    gap: 5px;
    transition: transform .4s;
    min-width: 335px;
    max-width: 335px;
    min-height: 419px;
    cursor: pointer;

    &:active {
        transform: scale(.8);
    }

    img {
        height: 250px;
        width: 300px;
        object-fit: cover;
        border-radius: 10px;
    }
    p {
        text-align: center;
    }
    button {
        padding: 10px 25px;
        border-radius: 15px;
        background-color: #002A48;
        color: #EDEDED;
        cursor: pointer;
    }
    h2 {
        text-align: center;
    }

`;
const OfertaBadge = styled(motion.div)`
    position: absolute;
    top: -10px;
    left: -10px;
    background: linear-gradient(45deg, #FF512F, #DD2476);
    color: white;
    font-weight: bold;
    padding: 5px 10px;
    border-radius: 12px;
    box-shadow: 0 0 10px rgba(255, 87, 34, 0.7);
    font-size: 14px;
    z-index: 2;
`;
export default NuestrosProductos;